module.exports = __webpack_public_path__ + "img/icon_menu_faq_2.9f03f32e.svg";